import { agentsEventHandlers } from './agents';
import { createUserChannelEventHandler, type UserEventHandlers } from './router';

export * from './router';
export * from './agents';

const userEventHandlerRegistry: UserEventHandlers = {
  ...agentsEventHandlers,
};

const handleUserChannelEvent = createUserChannelEventHandler(userEventHandlerRegistry);

export {
  handleUserChannelEvent,
};
